import addMount from "../../../core/addMount";
import MaterialGridManualEntry from "./MaterialGridManual.entry";

addMount({
  appName: "material-grid-manual",
  app: MaterialGridManualEntry
});
